var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8 64H26.2C19.4621 64 14 69.3726 14 76C14 82.6274 19.4621 88 26.2 88H62.8C69.5379 88 75 82.6274 75 76C75 69.3726 69.5379 64 62.8 64Z",
    fill: "#4FB96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.931 32H6.06897C2.71717 32 0 34.6863 0 38V50C0 53.3137 2.71717 56 6.06897 56H81.931C85.2828 56 88 53.3137 88 50V38C88 34.6863 85.2828 32 81.931 32Z",
    fill: "#3B96D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.931 0H6.06897C2.71717 0 0 2.68629 0 6V18C0 21.3137 2.71717 24 6.06897 24H81.931C85.2828 24 88 21.3137 88 18V6C88 2.68629 85.2828 0 81.931 0Z",
    fill: "#3B96D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.1883V47.0627C23.995 48.6829 22.6548 49.9952 21 50H9.00001C7.34521 49.9952 6.00495 48.6829 6.00001 47.0627V41.1883C5.99773 40.3481 6.37028 39.5488 7.02001 39L13.185 43.5381C14.2644 44.3166 15.7356 44.3166 16.815 43.5381L22.98 39C23.6297 39.5488 24.0023 40.3481 24 41.1883Z",
    fill: "#EFC319"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 38.7655L16.8195 43.4033C15.7375 44.1989 14.2625 44.1989 13.1805 43.4033L7 38.7655C7.54149 38.27 8.25035 37.9966 8.98496 38H21.015C21.7497 37.9966 22.4585 38.27 23 38.7655Z",
    fill: "#F2D45B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12Z",
    fill: "#FCD6AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16.5C20 17.3284 19.3284 18 18.5 18H12.5C11.6716 18 11 17.3284 11 16.5C11 14.0147 13.0147 12 15.5 12C17.9853 12 20 14.0147 20 16.5Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4286 43H31.5714C30.7036 43 30 42.3284 30 41.5C30 40.6716 30.7036 40 31.5714 40H39.4286C40.2964 40 41 40.6716 41 41.5C41 42.3284 40.2964 43 39.4286 43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4848 49H31.5152C30.6784 49 30 48.3284 30 47.5C30 46.6716 30.6784 46 31.5152 46H78.4848C79.3216 46 80 46.6716 80 47.5C80 48.3284 79.3216 49 78.4848 49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4286 11H31.5714C30.7036 11 30 10.3284 30 9.5C30 8.67157 30.7036 8 31.5714 8H39.4286C40.2964 8 41 8.67157 41 9.5C41 10.3284 40.2964 11 39.4286 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4848 17H31.5152C30.6784 17 30 16.3284 30 15.5C30 14.6716 30.6784 14 31.5152 14H78.4848C79.3216 14 80 14.6716 80 15.5C80 16.3284 79.3216 17 78.4848 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4861 82C39.0879 81.9999 38.7061 81.8418 38.4246 81.5605L35.4215 78.5605C34.8525 77.972 34.8606 77.0364 35.4398 76.4578C36.019 75.8792 36.9555 75.8711 37.5447 76.4395L39.6273 78.52L50.5975 70.3001C51.2609 69.803 52.202 69.9373 52.6996 70.6001C53.1972 71.2628 53.0627 72.203 52.3993 72.7001L40.3871 81.7C40.1275 81.8954 39.8112 82.0008 39.4861 82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.d0f20d66442bec7a3c2c72c95de9c61a.svg";
export { ForwardRef as ReactComponent };